import { useEffect, useState } from "react";
import { useDragger, getPostionCSSClass } from "../../../helper";

const DraggableNudge = ({
  customizeState,
  nudgeId,
  setNudgePosition,
  id,
  setCustomizeState,
}) => {
  const [userNudge_OfferTextFinal, setUserNudge_OfferTextFinal] = useState("");
  let left = 0;
  let top = 0;
  if (id === "desktop") {
    left = customizeState?.nudge?.desktopNudgePosition?.left;
    top = customizeState?.nudge?.desktopNudgePosition?.top;
  } else {
    top = customizeState?.nudge?.mobileNudgePosition?.top;
  }

  // useDragger(
  //   `nudgeID${nudgeId + id}`,
  //   left,
  //   top,
  //   setNudgePosition,
  //   id,
  //   setCustomizeState
  // );

  let hour = "00";
  let minute = "00";
  let timer = `${hour}:${minute}:00 hours`;

  let timeInMinute = customizeState?.nudgeOfferText?.minutes
    ? +customizeState?.nudgeOfferText?.minutes
    : 0;

  if (timeInMinute >= 60) {
    // add 0 before single digit
    hour = timeInMinute / 60;
    hour = hour < 10 ? `0${hour}` : hour;
    minute = timeInMinute % 60;
    minute = minute < 10 ? `0${minute}` : minute;
    timer = `${hour}:${minute}:00 hours`;
  } else {
    timeInMinute = timeInMinute < 10 ? `0${timeInMinute}` : timeInMinute;
    timer = `${timeInMinute}:00 minutes`;
  }
  const [nudgePosition, setNudgePostion] = useState("justify-right items-right")
  useEffect(() => {
    let userNudge_offerText = customizeState?.nudgeOfferText?.text;
    let userNudge_ExpiryTime = customizeState?.nudgeOfferText?.minutes;
    setUserNudge_OfferTextFinal(
      userNudge_offerText?.replace("{time}", userNudge_ExpiryTime)
    );
  }, [customizeState?.nudgeOfferText]);

  useEffect(() => {
    let nudgePositionVal = customizeState?.nudgePosition?.placement
    // console.log("nudgePositionVal", nudgePositionVal)
    setNudgePostion(nudgePositionVal)
  }, [customizeState?.nudgePosition])
  
  return (
    <div
      className={`h-full flex ${getPostionCSSClass(nudgePosition)}`}
    >
    <div
      id={`nudgeID${nudgeId + id}`}
      className="nudge shadow-md p-3 flex justify-center flex-col gap-3 w-[320px] text-center select-none"
      style={{
        backgroundColor: `${customizeState?.nudge?.backgroundColor}`,
        borderWidth: `${customizeState?.nudge?.borderWidth}px`,
        borderColor: `${customizeState?.nudge?.borderColor}`,
        borderStyle: `${customizeState?.nudge?.borderStyle}`,
        borderRadius: `${customizeState?.nudge?.borderRadius}px`,
        position: "absolute",
        marginLeft: `${customizeState?.nudgePosition?.margin_left}px`,
        marginTop: `${customizeState?.nudgePosition?.margin_top}px`,
        marginRight: `${customizeState?.nudgePosition?.margin_right}px`,
        marginBottom: `${customizeState?.nudgePosition?.margin_bottom}px`,
      }}
    >
      <span
        className="crossicon absolute font-bold cursor-pointer text-xs"
        style={{
          color: `${customizeState?.nudgeClosed?.textColor}`,
          fontSize: `${customizeState?.nudgeClosed?.fontSize}px`,
          top: `${customizeState?.nudgeClosed?.topPosition}px`,
          right: `${customizeState?.nudgeClosed?.rightPosition}px`,
        }}
      >
        X
      </span>
      <p
        className="text-sm text-gray-800 break-words"
        style={{
          fontStyle: `${customizeState?.nudgeOfferText?.fontStyle}`,
          color: `${customizeState?.nudgeOfferText?.textColor}`,
          backgroundColor: `${customizeState?.nudgeOfferText?.backgroundColor}`,
          borderColor: `${customizeState?.nudgeOfferText?.borderColor}`,
          borderStyle: `${customizeState?.nudgeOfferText?.borderStyle}`,
          borderRadius: `${customizeState?.nudgeOfferText?.borderRadius}px`,
        }}
      >
        <span className="nudgeText">{userNudge_OfferTextFinal}</span>
      </p>
      <p
        className="text-sm font-semibold px-4 py-1 break-words"
        style={{
          fontStyle: `${customizeState?.nudgeCouponCode?.fontStyle}`,
          color: `${customizeState?.nudgeCouponCode?.textColor}`,
          backgroundColor: `${customizeState?.nudgeCouponCode?.backgroundColor}`,
          borderWidth: `${customizeState?.nudgeCouponCode?.borderWidth}px`,
          borderColor: `${customizeState?.nudgeCouponCode?.borderColor}`,
          borderStyle: `${customizeState?.nudgeCouponCode?.borderStyle}`,
          borderRadius: `${customizeState?.nudgeCouponCode?.borderRadius}px`,
          display: `${customizeState?.nudgeCouponCode?.display}`,
        }}
      >
        {customizeState?.nudgeCouponCode?.text}
      </p>
      <p
        className="text-sm px-4 py-1 text-gray-300 break-words cursor-pointer"
        style={{
          fontStyle: `${customizeState?.nudgeCopyCode?.fontStyle}`,
          color: `${customizeState?.nudgeCopyCode?.textColor}`,
          backgroundColor: `${customizeState?.nudgeCopyCode?.backgroundColor}`,
          borderWidth: `${customizeState?.nudgeCopyCode?.borderWidth}px`,
          borderColor: `${customizeState?.nudgeCopyCode?.borderColor}`,
          borderStyle: `${customizeState?.nudgeCopyCode?.borderStyle}`,
          borderRadius: `${customizeState?.nudgeCopyCode?.borderRadius}px`,
        }}
      >
        {customizeState?.nudgeCopyCode?.text}
        </p>
        <p
          className="mt-[-14px]"
          style={{
            fontStyle: `${customizeState?.nudgeDisclaimerText?.fontStyle}`,
            color: `${customizeState?.nudgeDisclaimerText?.textColor}`,
            fontSize: `${customizeState?.nudgeDisclaimerText?.fontSize}px`,
            display: `${customizeState?.nudgeDisclaimerText?.display}`,
          }}
        >{customizeState?.nudgeDisclaimerText?.text}</p>
    </div>
    </div>
  );
};

export default DraggableNudge;
